import { Component } from '@angular/core';

@Component({
  selector: 'app-provider-service-search',
  templateUrl: './provider-service-search.component.html',
  styleUrls: ['./provider-service-search.component.scss']
})
export class ProviderServiceSearchComponent
{

}
